import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import * as BillActions from "../../../Redux/actions/billActions";
import contactProvider from "../../../../static/images/contactProvider.svg";
import equis from "../../../../static/images/X.svg";
import Modal from "../../utils/customModal";
import { formatNumber, loadingHtml } from "../../utils/functions";
import { getBillById } from "../../../Redux/reducer/bills";

const BillDetail = ({ billId, closeUrl, from }) => {
  const [state, setState] = useState({ modal: true, contentReady: false });

  const bill = useSelector((st) => getBillById(st));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const getInitialData = async () => {
      await dispatch(BillActions.getBillById(billId));
      setState({ ...state, contentReady: true });
    };

    getInitialData();
  }, []);

  const searchHistoryDate = (status, isForDate) => {
    let value = `${t("general.labels.na")}`;
    bill.historyOfApprovals.map((element) => {
      if (element.status === status) {
        value =
          isForDate === true
            ? new Date(element.createDate).toLocaleString("es-US")
            : element.createBy;
      }
    });
    return value;
  };

  return state.contentReady ? (
    <div className="bill-profile">
      <div className="actions-title">
        <img src={contactProvider} className="iconList" />
        <h3 className="new-profile-bill">{t("invoices.profile.title")}</h3>
        <Link className="left-flex" to={closeUrl}>
          <img src={equis} />
        </Link>
      </div>
      <div className="content-info">
        <div className="row">
          <div className="input col-lg-5">
            <label className="label" htmlFor="clientReference">
              {t("invoices.profile.form.clientReference")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="clientReference"
              id="clientReference"
              value={bill.referenceNumber}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="billsStatus">
              {t("invoices.profile.form.billsStatus")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billsStatus"
              id="billsStatus"
              value={t(`general.states.${bill.status}`)}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="identification">
              {t("invoices.profile.form.identification")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              value={
                undefined !== from && from == "proSite"
                  ? bill.company.businessId
                  : bill.provider.businessId
              }
              name="identification"
              id="identification"
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="billType">
              {t("invoices.profile.form.billType")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billType"
              id="billType"
              value={t(`general.bills.${bill.type}`)}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="dateOfIssue">
              {t("invoices.profile.form.dateOfIssue")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              value={`${new Date(bill.dateOfIssue).getUTCDate()}/${
                new Date(bill.dateOfIssue).getUTCMonth() + 1
              }/${new Date(bill.dateOfIssue).getUTCFullYear()}`}
              name="dateOfIssue"
              id="dateOfIssue"
              readOnly={true}
            />
          </div>
          {undefined !== from && from == "proSite" ? null : (
            <div className="input col-lg-5">
              <label className="label" htmlFor="billDateTimeLoad">
                {t("invoices.profile.form.billDateTimeLoad")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billDateTimeLoad"
                id="billDateTimeLoad"
                value={new Date(bill.createDate).toLocaleString("es-US")}
                readOnly={true}
              />
            </div>
          )}
          <div className="input col-lg-5">
            <label className="label" htmlFor="totalAmmount">
              {t("invoices.profile.form.totalAmmount")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="totalAmmount"
              id="totalAmmount"
              value={formatNumber(
                bill.totalAmount,
                bill.currencyDetail.currencySymbol
              )}
              readOnly={true}
            />
          </div>
          {undefined !== from && from == "proSite" ? null : (
            <div className="input col-lg-5">
              <label className="label" htmlFor="billDateTimeApproval">
                {t("invoices.profile.form.billDateTimeApproval")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billDateTimeApproval"
                id="billDateTimeApproval"
                value={searchHistoryDate("APPROVED", true)}
                readOnly={true}
              />
            </div>
          )}
          <div className="input col-lg-5">
            <label className="label" htmlFor="billNumber">
              {t("invoices.profile.form.billNumber")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billNumber"
              id="billNumber"
              value={bill.billNumber}
              readOnly={true}
            />
          </div>
          {undefined !== from && from == "proSite" ? null : (
            <div className="input col-lg-5">
              <label className="label" htmlFor="approvalUser">
                {t("invoices.profile.form.approvalUser")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="approvalUser"
                id="approvalUser"
                value={searchHistoryDate("APPROVED", false)}
                readOnly={true}
              />
            </div>
          )}
          <div className="input col-lg-5">
            <label className="label" htmlFor="providerName">
              {t("invoices.profile.form.providerName")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="providerName"
              id="providerName"
              value={bill.provider.companyName}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="billDateTimeAcceptance">
              {t("invoices.profile.form.billDateTimeAcceptance")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billDateTimeAcceptance"
              id="billDateTimeAcceptance"
              value={searchHistoryDate("ACCEPTED", true)}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="expirationDate">
              {t("invoices.profile.form.expirationDate")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="expirationDate"
              id="expirationDate"
              value={`${new Date(bill.expirationDate).getUTCDate()}/${
                new Date(bill.expirationDate).getUTCMonth() + 1
              }/${new Date(bill.expirationDate).getUTCFullYear()}`}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="billAceptanceUser">
              {t("invoices.profile.form.billAceptanceUser")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billAceptanceUser"
              id="billAceptanceUser"
              value={searchHistoryDate("ACCEPTED", false)}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="billCurrency">
              {t("invoices.profile.form.billCurrency")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billCurrency"
              id="billCurrency"
              value={bill.currency}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="billDateTimeProcessed">
              {t("invoices.profile.form.billDateTimeProcessed")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billDateTimeProcessed"
              id="billDateTimeProcessed"
              value={searchHistoryDate("PROCESSED", true)}
              readOnly={true}
            />
          </div>
          <div className="input col-lg-5">
            <label className="label" htmlFor="billDetail">
              {t("invoices.profile.form.billDetail")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billDetail"
              id="billDetail"
              value={bill.description}
              readOnly={true}
            />
          </div>
          {undefined !== from && from == "proSite" ? null : (
            <div className="input col-lg-5">
              <label className="label" htmlFor="billLoanNumber">
                {t("invoices.profile.form.billLoanNumber")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billLoanNumber"
                id="billLoanNumber"
                value={
                  bill.loanDetail === null
                    ? t("general.labels.na")
                    : bill.loanDetail.number
                }
                readOnly={true}
              />
            </div>
          )}

          <div className="input col-lg-5">
            <label className="label" htmlFor="billMountToProvider">
              {t("invoices.profile.form.billMountToProvider")}
            </label>
            <input
              className="input input--text input-w-aux__input input--active"
              type="text"
              name="billMountToProvider"
              id="billMountToProvider"
              value={
                bill.loanDetail === null
                  ? t("general.labels.na")
                  : formatNumber(
                      bill.loanDetail.providerPayAmount,
                      bill.currencyDetail.currencySymbol
                    )
              }
              readOnly={true}
            />
          </div>
          {undefined !== from && from == "proSite" ? null : (
            <div className="input col-lg-5">
              <label className="label" htmlFor="billReferenceProviderPayment">
                {t("invoices.profile.form.billReferenceProviderPayment")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billReferenceProviderPayment"
                id="billReferenceProviderPayment"
                value={
                  bill.loanDetail === null
                    ? t("general.labels.na")
                    : bill.loanDetail.referenceCharge
                }
                readOnly={true}
              />
            </div>
          )}

          {undefined !== from && from == "proSite" ? null : (
            <div className="input col-lg-5">
              <label className="label" htmlFor="billReferencePayment">
                {t("invoices.profile.form.billReferencePayment")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billReferencePayment"
                id="billReferencePayment"
                value={
                  bill.loanDetail === null
                    ? t("general.labels.na")
                    : bill.loanDetail.referencePay
                }
                readOnly={true}
              />
            </div>
          )}

          {undefined !== from && from == "proSite" ? null : (
            <div className="input col-lg-5">
              <label className="label" htmlFor="newExpirationDateBillForLoan">
                {t("invoices.profile.form.newExpirationDateBillForLoan")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="newExpirationDateBillForLoan"
                id="billReferenceProviderPayment"
                value={
                  bill.newExpirationDateBillForLoan === null
                    ? `${new Date(bill.expirationDate).getUTCDate()}/${
                        new Date(bill.expirationDate).getUTCMonth() + 1
                      }/${new Date(bill.expirationDate).getUTCFullYear()}`
                    : `${new Date(
                        bill.newExpirationDateBillForLoan
                      ).getUTCDate()}/${
                        new Date(
                          bill.newExpirationDateBillForLoan
                        ).getUTCMonth() + 1
                      }/${new Date(
                        bill.newExpirationDateBillForLoan
                      ).getUTCFullYear()}`
                }
                readOnly={true}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <Modal show={state.modal}>{loadingHtml()}</Modal>
  );
};

export default BillDetail;

/* 
export class BillDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: true, contentReady: false };
  }

  componentDidMount() {
    const { billId, actions } = this.props;

    return actions.getBillById(billId).then(() => {
      this.setState({ contentReady: true });
    });
  }

  searchHistoryDate = (status, isForDate) => {
    const { bill, t } = this.props;
    var value = `${t("general.labels.na")}`;
    bill.historyOfApprovals.map((element) => {
      if (element.status === status) {
        value =
          isForDate === true
            ? new Date(element.createDate).toLocaleString("es-US")
            : element.createBy;
      }
    });
    return value;
  };

  render() {
    const { bill, closeUrl, from, t } = this.props;
    const { contentReady } = this.state;

    return contentReady ? (
      <div className="bill-profile">
        <div className="actions-title">
          <img src={`/static/${contactProvider}`} className="iconList" />
          <h3 className="new-profile-bill">{t("invoices.profile.title")}</h3>
          <Link className="left-flex" to={closeUrl}>
            <img src={`/static/${equis}`} />
          </Link>
        </div>
        <div className="content-info">
          <div className="row">
            <div className="input col-lg-5">
              <label className="label" htmlFor="clientReference">
                {t("invoices.profile.form.clientReference")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="clientReference"
                id="clientReference"
                value={bill.referenceNumber}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billsStatus">
                {t("invoices.profile.form.billsStatus")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billsStatus"
                id="billsStatus"
                value={t(`general.states.${bill.status}`)}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="identification">
                {t("invoices.profile.form.identification")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                value={
                  undefined !== from && from == "proSite"
                    ? bill.company.businessId
                    : bill.provider.businessId
                }
                name="identification"
                id="identification"
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billType">
                {t("invoices.profile.form.billType")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billType"
                id="billType"
                value={t(`general.bills.${bill.type}`)}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="dateOfIssue">
                {t("invoices.profile.form.dateOfIssue")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                value={`${new Date(bill.dateOfIssue).getUTCDate()}/${
                  new Date(bill.dateOfIssue).getUTCMonth() + 1
                }/${new Date(bill.dateOfIssue).getUTCFullYear()}`}
                name="dateOfIssue"
                id="dateOfIssue"
                readOnly={true}
              />
            </div>
            {undefined !== from && from == "proSite" ? null : (
              <div className="input col-lg-5">
                <label className="label" htmlFor="billDateTimeLoad">
                  {t("invoices.profile.form.billDateTimeLoad")}
                </label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  name="billDateTimeLoad"
                  id="billDateTimeLoad"
                  value={new Date(bill.createDate).toLocaleString("es-US")}
                  readOnly={true}
                />
              </div>
            )}
            <div className="input col-lg-5">
              <label className="label" htmlFor="totalAmmount">
                {t("invoices.profile.form.totalAmmount")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="totalAmmount"
                id="totalAmmount"
                value={formatNumber(
                  bill.totalAmount,
                  bill.currencyDetail.currencySymbol
                )}
                readOnly={true}
              />
            </div>
            {undefined !== from && from == "proSite" ? null : (
              <div className="input col-lg-5">
                <label className="label" htmlFor="billDateTimeApproval">
                  {t("invoices.profile.form.billDateTimeApproval")}
                </label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  name="billDateTimeApproval"
                  id="billDateTimeApproval"
                  value={this.searchHistoryDate("APPROVED", true)}
                  readOnly={true}
                />
              </div>
            )}
            <div className="input col-lg-5">
              <label className="label" htmlFor="billNumber">
                {t("invoices.profile.form.billNumber")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billNumber"
                id="billNumber"
                value={bill.billNumber}
                readOnly={true}
              />
            </div>
            {undefined !== from && from == "proSite" ? null : (
              <div className="input col-lg-5">
                <label className="label" htmlFor="approvalUser">
                  {t("invoices.profile.form.approvalUser")}
                </label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  name="approvalUser"
                  id="approvalUser"
                  value={this.searchHistoryDate("APPROVED", false)}
                  readOnly={true}
                />
              </div>
            )}
            <div className="input col-lg-5">
              <label className="label" htmlFor="providerName">
                {t("invoices.profile.form.providerName")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="providerName"
                id="providerName"
                value={bill.provider.companyName}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billDateTimeAcceptance">
                {t("invoices.profile.form.billDateTimeAcceptance")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billDateTimeAcceptance"
                id="billDateTimeAcceptance"
                value={this.searchHistoryDate("ACCEPTED", true)}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="expirationDate">
                {t("invoices.profile.form.expirationDate")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="expirationDate"
                id="expirationDate"
                value={`${new Date(bill.expirationDate).getUTCDate()}/${
                  new Date(bill.expirationDate).getUTCMonth() + 1
                }/${new Date(bill.expirationDate).getUTCFullYear()}`}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billAceptanceUser">
                {t("invoices.profile.form.billAceptanceUser")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billAceptanceUser"
                id="billAceptanceUser"
                value={this.searchHistoryDate("ACCEPTED", false)}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billCurrency">
                {t("invoices.profile.form.billCurrency")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billCurrency"
                id="billCurrency"
                value={bill.currency}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billDateTimeProcessed">
                {t("invoices.profile.form.billDateTimeProcessed")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billDateTimeProcessed"
                id="billDateTimeProcessed"
                value={this.searchHistoryDate("PROCESSED", true)}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billDetail">
                {t("invoices.profile.form.billDetail")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billDetail"
                id="billDetail"
                value={bill.description}
                readOnly={true}
              />
            </div>
            <div className="input col-lg-5">
              <label className="label" htmlFor="billLoanNumber">
                {t("invoices.profile.form.billLoanNumber")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billLoanNumber"
                id="billLoanNumber"
                value={
                  bill.loanDetail === null
                    ? t("general.labels.na")
                    : bill.loanDetail.number
                }
                readOnly={true}
              />
            </div>

            <div className="input col-lg-5">
              <label className="label" htmlFor="billMountToProvider">
                {t("invoices.profile.form.billMountToProvider")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                name="billMountToProvider"
                id="billMountToProvider"
                value={
                  bill.loanDetail === null
                    ? t("general.labels.na")
                    : bill.loanDetail.providerPayAmount
                }
                readOnly={true}
              />
            </div>
            {undefined !== from && from == "proSite" ? null : (
              <div className="input col-lg-5">
                <label className="label" htmlFor="billReferenceProviderPayment">
                  {t("invoices.profile.form.billReferenceProviderPayment")}
                </label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  name="billReferenceProviderPayment"
                  id="billReferenceProviderPayment"
                  value={
                    bill.loanDetail === null
                      ? t("general.labels.na")
                      : bill.loanDetail.referenceCharge
                  }
                  readOnly={true}
                />
              </div>
            )}

            {undefined !== from && from == "proSite" ? null : (
              <div className="input col-lg-5">
                <label className="label" htmlFor="billReferencePayment">
                  {t("invoices.profile.form.billReferencePayment")}
                </label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  name="billReferencePayment"
                  id="billReferencePayment"
                  value={
                    bill.loanDetail === null
                      ? t("general.labels.na")
                      : bill.loanDetail.referencePay
                  }
                  readOnly={true}
                />
              </div>
            )}

            {undefined !== from && from == "proSite" ? null : (
              <div className="input col-lg-5">
                <label className="label" htmlFor="newExpirationDateBillForLoan">
                  {t("invoices.profile.form.newExpirationDateBillForLoan")}
                </label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  type="text"
                  name="newExpirationDateBillForLoan"
                  id="billReferenceProviderPayment"
                  value={
                    bill.newExpirationDateBillForLoan === null
                      ? `${new Date(bill.expirationDate).getUTCDate()}/${
                          new Date(bill.expirationDate).getUTCMonth() + 1
                        }/${new Date(bill.expirationDate).getUTCFullYear()}`
                      : `${new Date(
                          bill.newExpirationDateBillForLoan
                        ).getUTCDate()}/${
                          new Date(
                            bill.newExpirationDateBillForLoan
                          ).getUTCMonth() + 1
                        }/${new Date(
                          bill.newExpirationDateBillForLoan
                        ).getUTCFullYear()}`
                  }
                  readOnly={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    ) : (
      <Modal show={this.state.modal}>{loadingHtml()}</Modal>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    bill: getBillById(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(BillActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(BillDetail));
 */
